module.exports = __webpack_public_path__ + "img/yahoo_finance.512e466a.png";